<template>
    <vs-popup class="manage-wo-ccp-items-popup" :title="`MANAGE CCP ITEMS - ${wo_code}`" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow id="manage-wo-ccp-items-popup" :class="{ disabled: is_wo_complete }">

            <vx-card cardBorder noShadow v-for="ccp_item in ccp_item_list" :key="ccp_item.id" class="mb-3">
                <div class="flex mb-3">
                    <h5 class="mb-2 font-bold ml-0 mr-auto">{{ ccp_item.name || '' }}</h5>
                    <vs-checkbox color="success" class="ml-auto mr-0 font-bold"
                        v-model="ccp_item.is_selected">Select</vs-checkbox>
                </div>
                <p class="mb-4 italic">{{ ccp_item.description || '' }}</p>

                <div class="mb-3" v-if="ccp_item.file_paths && ccp_item.file_paths.length > 0">
                    <vs-collapse type="border">
                        <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevrons-down">
                            <div slot="header">
                                Documents ({{ ccp_item.file_paths.length }})
                            </div>
                            <FilePreviewGallery :removable="false" :files="ccp_item.file_paths" />
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mb-3">
                        <small class="label">Comments</small>
                        <vs-textarea v-model="ccp_item.comment" class="w-full" label="" val-icon-danger="icon-x"
                            val-icon-pack="feather" />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/2 mb-3" v-for="(field, index) in ccp_item.fields" :key="index">
                        <small class="label">{{ field.label }}</small>
                        <span v-if="field.type === 'Text'">
                            <vs-input v-model="field.value" name="name" class="w-full" label="" val-icon-danger="icon-x"
                                val-icon-pack="feather" />
                        </span>
                        <span v-if="field.type === 'Date'">
                            <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="field.value"
                                placeholder="Choose Date" />
                        </span>
                        <span v-if="field.type === 'Boolean'">
                            <YesNoToggle v-model="field.value" />
                        </span>
                        <span v-if="field.type === 'Drop Down'">
                            <v-select placeholder="" v-model="field.value" :options="field.options.labels"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            </v-select>
                        </span>
                        <span v-if="field.type === 'Image'">
                            <div v-if="field.value" class="mb-2">
                                <FilePreviewGallery :removable="!is_wo_complete" :files="[field.value]" @remove="$set(field, 'value', '')" />
                            </div>
                            <multi-file-uploader
                                v-if="!field.value && !is_wo_complete"
                                v-on:onSetFileName="value => $set(field, 'value', value)"
                                :file="''"
                                file_path="work-order/ccp-items"
                                :condition="true"
                            />
                        </span>
                        <span v-if="isFieldInvalid(field, ccp_item.is_selected)"
                            class="mt-0 text-xs text-danger">This field is required</span>
                    </div>
                </div>
            </vx-card>
            <div class="flex flex-wrap items-center justify-end mt-8" v-if="!is_wo_complete">
                <vs-button :disabled="selected_ccp_count === 0 || !is_form_complete" @click.stop="onClickSave"
                    button="submit" class="mt-2 ml-auto">
                    Save Changes
                </vs-button>
            </div>
        </vx-card>
    </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ManufacturingRepository = RepositoryFactory.get('manufacturing')

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue"
import MultiFileUploader from "@/components/shared/MultiFileUploader.vue"
import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

function initialState() {
    return {
        open: false,
        wo_id: null,
        wo_code: null,
        formulation_type: '',
        is_wo_complete: false, 
        ccp_item_list: [],
        selected_ccp_item_list: []
    }
}
export default {
    name: 'ManageWorkOrderCcpItemsPopup',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id, code, formulation_type, is_wo_complete) {
            try {
                await Object.assign(this.$data, initialState())
                this.wo_id = id
                this.wo_code = code
                this.formulation_type = formulation_type
                this.is_wo_complete = is_wo_complete
                this.open = true
                await this.fetchCcpItemList()
                await this.fetchWorkOrderSelectedCcpItems()
            } catch (error) {
                
            }
        },
        async fetchCcpItemList() {
            try {
                const { data } = (await ManufacturingRepository.fetchApplicableCcpItems(this.wo_id)).data
                this.ccp_item_list = data.map(ccp => {
                    if (ccp.fields && Array.isArray(ccp.fields)) {
                        ccp.fields = ccp.fields.map(field => {
                            if (field.value === undefined) {
                                this.$set(field, 'value', field.type === 'Boolean' ? false : '')
                            }
                            return field
                        })
                    }
                    return ccp
                })
            } catch (error) {
                this.convertAndNotifyError(error)
            } finally {

            }
        },
        async fetchWorkOrderSelectedCcpItems() {
            try {
                const { data } = (await ManufacturingRepository.fetchWorkOrderSelectedCcpItems(this.wo_id)).data
                this.selected_ccp_item_list = data

                this.ccp_item_list = this.ccp_item_list.map((ccp) => {
                    const selected = this.selected_ccp_item_list.find(selected_ccp => selected_ccp.ccp_item_id === ccp.id)

                    this.$set(ccp, 'is_selected', !!selected)
                    this.$set(ccp, 'comment', selected ? selected.comment || '' : '')
                    this.$set(ccp, 'responded_by', selected && selected.responded_by ? selected.responded_by.name : '')

                    if (selected && selected.responses && selected.responses.length > 0) {
                        this.$set(ccp, 'fields', ccp.fields.map(field => {
                            const response = selected.responses.find(r => r.ccp_item_field_id === field.id)
                            if (response) {
                                this.$set(field, 'value', response.ccp_item_field.type === 'Boolean' ? (response.value === '1' ? true : false) : response.value)
                            } else {
                                this.$set(field, 'value', field.type === 'Boolean' ? false : '')
                            }
                            return field
                        }))
                    }

                    return ccp
                })

            } catch (error) {
                this.convertAndNotifyError(error)
            } finally {

            }
        },
        async onClickSave() {
            try {
                let payload = {
                    ccp_items: this.ccp_item_list.filter(ccp => ccp.is_selected).map(ccp => {
                        return {
                            id: ccp.id,
                            comment: ccp.comment,
                            file_paths: [],
                            responses: ccp.fields.map(field => {
                                return {
                                    field_id: field.id,
                                    value: field.value || '',
                                    comment: ''
                                }
                            })
                        }
                    })
                }
                await ManufacturingRepository.updateWorkOrderWithCcpItem(this.wo_id, payload)
                this.$emit('refreshData')
                this.open = false
            } catch (error) {
                this.convertAndNotifyError(error)
            } finally {

            }
        },
        isFieldInvalid(field, is_selected) {
            if (!field.is_required || !is_selected) return false

            if (field.type === 'Boolean') {
                return field.value === null || field.value === undefined || field.value === ''
            }
            return !field.value || field.value.toString().trim() === ''
        }
    },
    watch: {

    },
    components: {
        'v-select': vSelect,
        flatPickr,
        FilePreviewGallery,
        MultiFileUploader,
        YesNoToggle
    },
    computed: {
        selected_ccp_count() {
            return this.ccp_item_list.filter(ccp => ccp.is_selected).length
        },
        is_form_complete() {
            let is_complete = true
            this.ccp_item_list.forEach(ccp => {
                if (ccp.is_selected) {
                    ccp.fields.forEach(field => {
                        if (field.is_required) {
                            if (field.type === 'Boolean') {
                                if (field.value === null || field.value === undefined || field.value === '') {
                                    is_complete = false
                                }
                            } else {
                                if (!field.value || field.value.toString().trim() === '') {
                                    is_complete = false
                                }
                            }
                        }
                    })
                }
            })
            return is_complete
        }
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.manage-wo-ccp-items-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
}
.disabled {
  pointer-events: none;
  opacity: 0.7;
}

.disabled a {
  color: #888;
}
</style>